import React from 'react';
import classnames from 'classnames';
import SubmissionDetails from '../SubmissionDetails';
import TextContent from '../DeviationViews/Details/_partials/TextContent';
import { isExtendedDeviationFullyLoaded } from '../DeviationPage/redux/helpers';
import { normalizePremiumFolderData } from '../utils/normalizePremiumFolderData';
import { useFlag } from '../redux/flags/hooks';
import PremiumCover from './_partials/PremiumCover';
import JournalViewer from '../DaEditorWrapper/Viewer/Journal';
import TextRenderer from '../TextRenderer';
import Stats from '../SubmissionDetails/_partials/Stats';
import s from './LiteratureContent.actionbarrr.scss';
var LiteratureContent = function (_a) {
    var textContent = _a.deviation.textContent, deviation = _a.deviation, _b = _a.withArtist, withArtist = _b === void 0 ? true : _b;
    var isExtendedLoaded = isExtendedDeviationFullyLoaded(deviation);
    var isPremiumLocked = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData, useFlag('premium_folders')).isPremiumLocked;
    return (React.createElement(React.Fragment, null,
        withArtist && (React.createElement("div", { className: s['author-block'] },
            React.createElement(SubmissionDetails, { deviation: deviation }),
            "\u00A0")),
        React.createElement("div", { className: s['stats'] },
            React.createElement(Stats, { deviation: deviation })),
        React.createElement("div", { className: classnames(s['wrapper'], isPremiumLocked && s['wrapper-with-paywall']) }, isExtendedLoaded &&
            (isPremiumLocked ? (React.createElement(React.Fragment, null,
                React.createElement(TextRenderer, { className: s['text-content-pf'], textContent: textContent, reactViewer: JournalViewer, viewerKey: deviation.deviationId, legacyTheme: "journal" }),
                React.createElement(PremiumCover, { deviation: deviation }))) : (React.createElement(TextContent, { className: s['text-content'], textContent: textContent, deviationId: deviation.deviationId }))))));
};
LiteratureContent.displayName = 'LiteratureContent';
export default LiteratureContent;
//# sourceMappingURL=LiteratureContent.actionbarrr.js.map